/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	// ver1.0.1
	// ヒーローヘッダー　100vhのスマホ対応
	function setHeight() {
	  let vh = window.innerHeight * 0.01;
	}
	setHeight();

	var menuState = false;
	var dropState = false;

	window.addEventListener("load", function () {
	  $(".mainSlider").each(function () {
	    const $this = $(this);
	    const data = $this.data();

	    const defaultOptions = {
	      dots: data["dot"] !== false,
	      arrow: data["arrow"] !== false,
	      infinite: true,
	      autoplay: true,
	      autoplaySpeed: 5000,
	      fade: true,
	      speed: 300,
	      lazyLoad: "progressive",
	      slidesToShow: 1,
	      slidesToScroll: 1
	    };

	    const slideCount = $this.children("li").length;
	    const randomStart = Math.floor(Math.random() * slideCount);

	    if (data["center"] === true) {
	      $.extend(defaultOptions, {
	        centerMode: true,
	        centerPadding: "30px",
	        variableWidth: true
	      });
	    } else if (data["fade"] === true) {
	      $.extend(defaultOptions, {
	        fade: true,
	        pauseOnFocus: false,
	        pauseOnHover: false
	      });
	      $this.on({
	        beforeChange: function (event, slick, currentSlide, nextSlide) {
	          $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
	          $(".slick-slide", this).eq(nextSlide).addClass("fadeAnimetion");
	        },
	        afterChange: function () {
	          $(".preve-slide", this).removeClass("preve-slide fadeAnimetion");
	        }
	      });
	      $this.find(".slick-slide").eq(0).addClass("fadeAnimetion");
	    } else {
	      $.extend(defaultOptions, {
	        initialSlide: randomStart
	      });
	    }

	    $this.slick(defaultOptions);
	  });

	  const $contentSliders = $(".contentsSlider");
	if ($contentSliders.length) {
	  $contentSliders.each(function () {
	    const $this = $(this);
	    const pcshow = $this.data("pcshow") || 4;
	    const pcscroll = $this.data("pcscroll") || 4;
	    const spshow = $this.data("spshow") || 2;
	    const spscroll = $this.data("spscroll") || 2;
	    const infinite = !($this.data("infinite") == false || $this.hasClass("itemList--ranking"));

	    const defaultOptions = {
	      dots: false,
	      arrow: true,
	      infinite: infinite,
	      lazyLoad: "progressive",
	      slidesToShow: pcshow,
	      slidesToScroll: pcscroll,
	      autoplay: true,
	      autoplaySpeed: 5000,
	      speed: 150,
	      swipeToSlide: true,
	      responsive: [
	        {
	          breakpoint: 991,
	          settings: {
	            slidesToShow: 3,
	            slidesToScroll: 3,
	          },
	        },
	        {
	          breakpoint: 768,
	          settings: {
	            slidesToShow: spshow,
	            slidesToScroll: spscroll,
	          },
	        },
	      ],
	    };

	    $this.slick(defaultOptions);
	  });
	}

	  if ($(".mainVisual--integrate").length && $(".hdr--integrate").length) {
	    var hdr = $(".hdr--integrate");
	    hdr.addClass("active");
	    $(window).on("scroll", function (event) {
	      var scroll = $(window).scrollTop();
	      if (scroll > 300) {
	        hdr.addClass("integrate--fixed");
	      } else {
	        hdr.removeClass("integrate--fixed");
	      }
	    });
	  } else if ($(".hdr--integrate").length) {
	    hdrFixed($(".hdr--integrate"));
	  }

	  // 初期化
	  sNavOut(".header__nav");

	  // ナビ固定
	  // 共通
	  // if ($(".hdrFixed").length) {
	  //   hdrFixed($(".hdrFixed"));
	  // } else {
	  //   var ua = navigator.userAgent;
	  //   // タブレット・スマートフォン時
	  //   if (
	  //     ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
	  //       ua.indexOf("Mobile") > 0) ||
	  //     ua.indexOf("iPad") > 0
	  //   ) {
	  //     if ($(".hdrFixed--sp").length) {
	  //       hdrFixed($(".hdrFixed--sp"));
	  //     }
	  //     // PC
	  //   } else {
	  //     if ($(".hdrFixed--pc").length) {
	  //       hdrFixed($(".hdrFixed--pc"));
	  //     }
	  //   }
	  // }

	  function hdrFixed(target) {
	    target.after('<div class="h_box">&nbsp;</div>');
	    var h = target.height();
	    var h_top = target.offset().top;
	    $(".h_box").height("0");
	    $(window).on("load scroll resize", function (event) {
	      var scroll = $(window).scrollTop();
	      if (scroll >= h_top) {
	        target.css({
	          position: "fixed",
	          top: "0px",
	          width: "100%",
	          "z-index": "998",
	        });
	        $(".h_box").height(h);
	      } else {
	        target.css({
	          position: "",
	        });
	        $(".h_box").height("0");
	      }
	    });
	  }
	});

	// ハンバーガーメニュー展開
	$(document).on("click", ".menuToggle", function () {
	  $("#drawer").toggleClass("open");
	  $("#overlay").toggleClass("open");
	  $("body").toggleClass("open");
	  return false;
	});

	$(document).on("click", ".menuClose", function () {
	  $("#drawer").removeClass("open");
	  $("#overlay").removeClass("open");
	  $("body").removeClass("open");
	  return false;
	});

	// SPのみアコーディオン
	$(document).on("click", ".sp-toggle", function () {
	  var windowWidth = $(window).width();
	  if (windowWidth < 768) {
	    $(this).next("ul").slideToggle();
	    $(this).toggleClass("open");
	  }
	});

	$(document).on("click", ".hdrSearch--toggle > span,.hdrSearch--toggle > a", function () {
	  const $this = $(this);
	  const $icon = $this.find(".material-icons");
	  const iconText = $icon.text();

	  $this.next().slideToggle();
	  if (iconText === "search") {
	    $icon.text("close");
	  } else if (iconText === "close") {
	    $icon.text("search");
	  }

	  return false;
	});


	// ナビゲーション　子要素展開
	$(function () {
	  var ua = navigator.userAgent;
	  // タブレット・スマートフォン時
	  if (
	    ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
	      ua.indexOf("Mobile") > 0) ||
	    ua.indexOf("iPad") > 0
	  ) {
	    $(".hasChildren > a")
	      .on("mouseenter touchstart", function () {
	        $(this).toggleClass("open");
	        $(this).next("ul,.megaMenu").toggleClass("open");
	        return false;
	      })
	      .on("mouseleave touchend", function () {
	        return false;
	      });
	    $(".hasChildren .hasChildren--close > a").on(
	      "mouseenter touchstart",
	      function () {
	        $(this).parents("ul").removeClass("open").prev("a").removeClass("open");
	        return false;
	      }
	    );
	  } else {
	    // PC時
	    $(".hasChildren")
	      .on("mouseenter", function () {
	        $(this).children("a").addClass("open");
	        $(this).children("ul,.megaMenu").addClass("open");
	      })
	      .on("mouseleave", function () {
	        $(this).children("a").removeClass("open");
	        $(this).children("ul,.megaMenu").removeClass("open");
	      });
	  }
	});

	$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span,.hasChildren--click > h3', function() {
	  const $this = $(this);
	  const $ul = $this.next('ul');

	  if ($this.hasClass('open')) {
	    $this.removeClass('open');
	    $ul.removeClass('open').slideUp();
	  } else {
	    const $gNav = $this.closest('.gNav');
	    $gNav.find('.hasChilds > span').removeClass('open');
	    $gNav.find('.hasChilds > span').next('ul').removeClass('open').slideUp(0);
	    $this.addClass('open');
	    $ul.addClass('open').slideDown();
	  }

	  return false;
	});


	$(document).on("click", ".hasChildren--clickSP > h2", function () {
	  var windowWidth = $(window).width();
	  if (windowWidth < 768) {
	    var next = $(this).next();
	    if ($(this).hasClass("open")) {
	      $(this).removeClass("open");
	      next.removeClass("open");
	      next.slideUp();
	    } else {
	      const all = $(this)
	        .parents("li")
	        .parents()
	        .parents(".gNav")
	        .find(".hasChilds > span");
	      all.removeClass("open");
	      all.next().removeClass("open").slideUp(0);
	      $(this).addClass("open");
	      next.addClass("open").slideDown();
	    }
	    return false;
	  }
	});

	// SPヘッダーD　カテゴリーナビ
	$(document).on("click", ".hdrCatMenu--toggle", function () {
	  if ($(this).hasClass("open")) {
	    $(this).removeClass("open");
	    $(this).next("ul").removeClass("open").slideUp();
	  } else {
	    $(".hdrCatMenu--toggle.open").next("ul").hide().removeClass("open");
	    $(".hdrCatMenu--toggle.open").removeClass("open");
	    $(this).addClass("open");
	    $(this).next("ul").addClass("open").slideDown();
	  }
	  return false;
	});

	function sNavIn(_this) {
	  $(_this).addClass("open");
	  $(".menuBg--close").addClass("open");
	  $(_this).css({
	    left: 0,
	  });
	}

	function sNavOut(_this) {
	  var windowWidthMinus = document.documentElement.clientWidth * -1;
	  $(_this).removeClass("open");
	  $(".menuBg--close").removeClass("open");
	  $(_this).css({
	    left: windowWidthMinus,
	  });
	}

	// スクロールボタン
	$(function () {
	  if ($(".mainSliderSec").length || $(".mainVisual").length) {
	    if ($(".mainVisual--hero").length) {
	      var position = $(window).height();
	    } else if ($(".mainSliderSec").length) {
	      var position = $(".mainSliderSec + * ").offset().top;
	    } else {
	      var position = $(".mainVisual + * ").offset().top;
	    }
	    $("#scrollBtn").click(function () {
	      $("html,body").animate(
	        {
	          scrollTop: position, // さっき変数に入れた位置まで
	        },
	        {
	          queue: false, // どれくらい経過してから、アニメーションを始めるか。キュー[待ち行列]。falseを指定すると、キューに追加されずに即座にアニメーションを実行。
	        }
	      );
	      return false;
	    });
	  }
	});

	// TOPに戻るボタン
	$(function() {
	  const $toTop = $("#toTop");

	  if ($toTop.length) {
	    $toTop.hide();

	    $(window).on('scroll', function() {
	      if ($(this).scrollTop() > 800) {
	        $toTop.fadeIn();
	      } else {
	        $toTop.fadeOut();
	      }
	    });

	    $toTop.on('click', function() {
	      $("body,html").animate({scrollTop: 0}, 500);
	      return false;
	    });
	  }
	});

	// 検索ランキングキーワード
	$(function () {
	  // テキストボックスにフォーカス時、フォームの背景色を変化
	  $('.keywordRanking input[type="text"]')
	    .focusin(function (e) {
	      $(this)
	        .parents(".keywordRanking")
	        .next(".keywordRanking__toggle")
	        .addClass("open");
	    })
	    .focusout(function (e) {
	      setTimeout(function () {
	        $(".keywordRanking__toggle.open").removeClass("open");
	      }, 200);
	    });
	});

	// マルチグリッド横スクロール
	$(function () {
	  $(".lightSlider .multiGrid").each(function () {
	    const $grid = $(this);
	    const $slider = $grid.parents(".lightSlider");

	    $grid.after('<div class="prevBtn"></div>', '<div class="nextBtn"></div>');
	  
	    const $leftButton = $grid.next(".prevBtn");
	    const $rightButton = $leftButton.next(".nextBtn");
	  
	    let width = 0;
	    $grid.children("li").each(function () {
	      width += $(this).outerWidth(true);
	    });
	  
	    //右へ
	    $rightButton.click(function () {
	      $grid.animate({ scrollLeft: $grid.scrollLeft() + 600 }, 300);
	      return false;
	    });

	    //左へスクロールで表示
	    $grid.scroll(function () {
	      if ($grid.scrollLeft() < width - $grid.width()) {
	        $rightButton.fadeIn();
	      } else {
	        $rightButton.fadeOut();
	      }
	    });

	    //左へ
	    $leftButton.click(function () {
	      $grid.animate({ scrollLeft: $grid.scrollLeft() - 600 }, 300);
	      return false;
	    });

	    //右へスクロールで表示
	    $leftButton.hide();
	    $grid.scroll(function () {
	      if ($grid.scrollLeft() > 0) {
	        $leftButton.fadeIn();
	      } else {
	        $leftButton.fadeOut();
	      }
	    });
	  });
	});




	// テキスト横スクロール
	var spSwiperDone = false;
	$(window).on("load resize", function (event) {
	  if (
	    window.innerWidth < 992 &&
	    spSwiperDone == false &&
	    $(".spSwiper").length
	  ) {
	    $(".spSwiper").slick({
	      autoplay: false,
	      speed: 300,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      centerMode: false,
	      variableWidth: true,
	      touchMove: true,
	      swipeToSlide: true,
	      infinite: false,
	    });

	    spSwiperDone = true;
	  }
	});

	// タブ切り替え
	$(function() {
	  $(".tabSwitch > li").on('click', function() {
	    var $this = $(this);
	    if (!$this.hasClass('active')) {
	      $this.siblings().removeClass('active');
	      $this.addClass('active');

	      var tabNum = $this.index();
	      var $tabContents = $this.closest(".tab").find(".tabContent");
	      
	      $tabContents.hide().eq(tabNum).fadeIn("500");
	    }
	  });
	});

	$(function() {
	  if ($(".wow").length) { 
	    $(window).on("scroll", function () {
	      $(".wow").each(function () {
	        var position = $(this).offset().top;
	        var scroll = $(window).scrollTop();
	        var windowHeight = $(window).height();
	        if (scroll > position - windowHeight + windowHeight / 4) {
	          $(this).addClass("animated");
	        }
	      });
	    });
	  }
	});

	if (window.innerWidth < 767) {
	  $(".cateList__hasChildren").click(function () {
	    $(this).toggleClass("open").next().toggleClass("open").slideToggle();
	    return false;
	  });
	}

	// 詳細検索モーダル
	$(document).on("click", "#mdsBg,#mdsClose", function () {
	  $("#modalDetailSearch").removeClass("open");
	  return false;
	});

	$(document).on("click", "#openDetailSearch", function () {
	  $("#modalDetailSearch").addClass("open");
	  return false;
	});

	//CUSTOM
	$(function() {
	  $('.menu-item').click(function() {
	      $(this).children('.subMenu').stop().slideToggle(500);
	  });
	});

	$(function() {
	  $('.fNav_head2').click(function() {
	      $(this).next('.fNav_menu').stop().slideToggle(500);
	  });
	});  

	$(function() {
	  $('#searchClose').click(function() {
	      $(this).parents('.hdrSearch__wrap').stop().slideToggle(500);
	  });
	});

	document.addEventListener('DOMContentLoaded', function() {
	  document.querySelectorAll('.menu-item').forEach(item => {
	    item.addEventListener('click', function() {
	      // 現在のアイテムの active クラスをトグルする
	      this.classList.toggle('active');
	    });
	  });
	  document.querySelectorAll('.fNav_head2').forEach(item => {
	    item.addEventListener('click', function() {
	      // 現在のアイテムの active クラスをトグルする
	      this.classList.toggle('active');
	    });
	  });
	});

	document.addEventListener('DOMContentLoaded', function() {
	  const drawerOpen = document.getElementById('menuBtn');
	  const drawerClose = document.getElementById('drawerBg'); 
	  const svgs = document.querySelectorAll('.iconNav li svg');

	  drawerOpen.addEventListener('click', function() {
	    var drawer = document.getElementById('drawer2');
	    drawerOpen.classList.toggle('active');
	    drawerClose.classList.toggle('active');
	    drawer.classList.toggle('open');
	    drawerClose.classList.toggle('open');
	    if (drawerOpen.classList.contains('active')) {
	      svgs.forEach(svg => {
	        svg.style.setProperty('fill', '#1b1b1b', 'important');
	      });
	    }else{
	      svgs.forEach(svg => {
	        svg.setAttribute('style', '');
	      });
	    }
	  });
	  
	  drawerClose.addEventListener('click', function() {
	    var drawer = document.getElementById('drawer2');
	    drawerOpen.classList.toggle('active');
	    drawerClose.classList.toggle('active');
	    drawer.classList.remove('open');
	    svgs.forEach(svg => {
	      svg.setAttribute('style', '');
	    });
	    setTimeout(function() {
	        drawerClose.classList.toggle('open');
	    }, 400);
	  });


	});

	document.addEventListener('DOMContentLoaded', function() {
	  function checkWindowSize() {
	    const elements = document.querySelectorAll('.fNav_menu, .fNav_menu_removed');
	    const headElements = document.querySelectorAll('.fNav_head2');
	    
	    elements.forEach(element => {
	      if (window.innerWidth >= 768) {
	        // 768px以下のとき、クラスを削除
	        element.classList.remove('fNav_menu');
	        element.classList.add('fNav_menu_removed'); // 削除したことを記録するためのクラスを追加
	        element.style.display = 'block';
	      } else {
	        // 768px以上のとき、クラスを追加
	        element.classList.add('fNav_menu');
	        element.classList.remove('fNav_menu_removed'); // 記録用のクラスを削除
	        headElements.forEach(headElement => {
	          headElement.classList.remove('active');
	        });
	        element.style.display = 'none';
	      }
	    });
	  }

	  // 初期ロード時にチェック
	  checkWindowSize();

	  // ウィンドウリサイズ時にチェック
	  window.addEventListener('resize', checkWindowSize);
	});

	// ＊＊＊＊＊＊＊
	// CMS固有
	// ＊＊＊＊＊＊＊

	// CCシステムの商品カルーセル解除
	// $('.fs-c-productListCarousel__list__itemTrack').each(function() {
	//   // 商品表示パーツのクラスを付与
	//   $(this).addClass('itemList itemList--typeC itemList-pc--4 itemList-sp--2');
	//   $(this).parents('.fs-c-productListCarousel__list').removeClass('fs-c-productListCarousel__list').addClass('ccItemListContainer');
	//   $(this).removeClass('fs-c-productListCarousel__list__itemTrack');
	//   $(this).find('article.fs-c-productListCarousel__list__item.fs-c-productListItem').each(function() {
	//     $(this).removeClass('fs-c-productListCarousel__list__item fs-c-productListItem').addClass('itemList__unit');
	//     // 商品名
	//     var name = $(this).find('.fs-c-productListItem__productName .fs-c-productName__name').text();
	//     // 画像をdataLazyから抽出してパース
	//     var dataLazy = '';
	//     var img = '';
	//     $(this).find('img.fs-c-productImage__image').each(function() {
	//       dataLazy = $(this).attr('data-lazy');
	//       $(this).attr('src', dataLazy);
	//     });
	//     if (dataLazy != '') {
	//       img = '<img src="' + dataLazy + '" alt="' + name + '" class="itemImg" />';
	//     }
	//     // 商品URL
	//     var url = $(this).find('.fs-c-productListItem__productName a').attr('href');
	//     // 価格
	//     var price = $(this).find('.fs-c-productListItem__prices.fs-c-productPrices').html();
	//     // 在庫表示
	//     var stockClass = $(this).find('.fs-c-productListItem__lowInStock.fs-c-productListItem__notice.fs-c-productStock').attr('class');
	//     console.log(stockClass);
	//     var stock = $(this).find('.fs-c-productListItem__lowInStock.fs-c-productListItem__notice.fs-c-productStock').html();
	//     if (stock != undefined) {
	//       stock = '<div class="' + stockClass + '">' + stock + '</div>';
	//     } else {
	//       stock = '';
	//     }
	//     // ボタン＆お気に入り
	//     var btn = $(this).find('.fs-c-productListItem__control.fs-c-buttonContainer');
	//     // パース
	//     var html = '<a class="itemWrap" href="' + url + '">' + img + '<p class="itemName">' + name + '</p>' + price + stock + '</a>';
	//
	//     $(this).html(html);
	//
	//     $('.fs-c-productListCarousel__ctrl').hide();
	//   });
	//
	//   $('.fs-c-button--carousel').hide();
	// });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/***/ })
/******/ ]);